const Config = {
  baseURL: "http://new.jacklearn.club:8096/znkf-api/",
}

export default Config
